export const defaultBlueprint = {
  connectionConfig: { type: "database" },
  fieldMapping: {
    required: {},
    optional: {},
  },
  /*
  fieldMapping: {
    required: {
      work-order: {
        work_order_id: {
          source: {
            table: "",
            column: "",
            joinConditions: [{ sourceTable: "", sourceColumn: "", targetTable: "", targetColumn: "" }],
            filterConditions: {
              conditions: [{ operator: "", value: "" }],
              note: "",
              },
            transformations: { type: "", formula: "", content: "", note: "" } },
            description: "",
        },
      },
    },
    optional: {},
  },
  */
  syncRule: {
    device: {
      matchingField: ["deviceName"],
      matchingStrategy: "contains",
      fallbackAction: "create",
    },
    station: {
      matchingField: ["stationName"],
      matchingStrategy: "contains",
      fallbackAction: "null",
    },
    worker: {
      matchingField: ["workerId"],
      matchingStrategy: "exact",
      fallbackAction: "create",
    },
    product: {
      matchingField: ["productNumber", "productName"],
      matchingStrategy: "exact",
      fallbackAction: "create",
    },
    operation: {
      matchingField: ["opCode", "opName", "opOrder"],
      matchingStrategy: "exact",
    },
  },
  updateRule: {
    updateCondition: "specific",
    columns: [{ columnSource: "wooh", columnName: "更新時間", note: "" }],
  },
  blueprintMemo: "",
};

export const databaseType = [
  { value: "oracle", label: "Oracle（大型企業 ERP）" },
  { value: "mysql", label: "MySQL（常見於開源 ERP）" },
  { value: "sqlserver", label: "SQL Server（微軟生態系）" },
  { value: "postgresql", label: "PostgreSQL（企業級選擇）" },
];

export const apiAuth = [
  { value: "apikey", label: "API Key" },
  { value: "oauth", label: "OAuth 2.0" },
  { value: "bearer", label: "Bearer Token" },
  { value: "basic", label: "Basic Auth" },
];

export const blueprintKeyTransform = {
  connectionConfig: "連線配置",
  type: "類型",
  database: "資料庫",
  host: "主機位址",
  port: "連接埠",
  username: "使用者名稱",
  password: "密碼",
  api: "API 設定",
  baseUrl: "基礎 URL",
  authentication: "認證方式",
  credentials: "認證憑證",
  timeout: "超時時間（秒）",
  retryCount: "重試次數",
  fieldMapping: "欄位映射",
  required: "必填欄位",
  optional: "選填欄位",
  "work-order": "大工單",
  product: "物料",
  "work-order-op-history": "小工單",
  route: "途程",
  operation: "工序",
  equipment: "設備",
  worker: "員工",
  source: "來源設定",
  description: "描述",
  table: "資料表",
  column: "欄位",
  joinConditions: "Join 條件",
  sourceTable: "來源資料表",
  sourceColumn: "來源欄位",
  targetTable: "目標資料表",
  targetColumn: "目標欄位",
  filterConditions: "篩選條件",
  conditions: "條件",
  operator: "操作符",
  value: "值",
  note: "備註",
  transformations: "資料轉換",
  formula: "公式",
  content: "內容",
  syncRule: "同步規則",
  device: "設備",
  matchingField: "匹配欄位",
  matchingStrategy: "匹配策略",
  fallbackAction: "找不到時的處理方式",
  station: "報工站",
  updateRule: "更新規則",
  updateCondition: "更新條件",
  columns: "欄位",
  columnSource: "欄位來源",
  columnName: "欄位名稱",
  condition: "條件",
  blueprintMemo: "藍圖筆記",
};

export const allFields = {
  /* --- work order (R) --- */
  work_order_id: {
    key: "work_order_id",
    label: "工單單號",
    description: "唯一識別工單的編號",
  },
  qty: { key: "qty", label: "數量", description: "工單的生產數量" },
  is_asap: {
    key: "is_asap",
    label: "是否急單",
    description: "標示此工單是否為緊急工單",
  },
  status: { key: "status", label: "狀態", description: "工單當前的執行狀態" },
  /* --- product (R) --- */
  product_number: {
    key: "product_number",
    label: "物料編號",
    description: "唯一識別物料的編號",
  },
  product_name: {
    key: "product_name",
    label: "物料名稱",
    description: "物料的名稱描述",
  },
  product_is_active: {
    key: "product_is_active",
    label: "啟用",
    description: "物料是否啟用",
  },
  /* --- route (R) --- */
  route_name: {
    key: "route_name",
    label: "途程名稱",
    description: "製程路徑的名稱",
  },
  /* --- operation (R) --- */
  op_name: {
    key: "op_name",
    label: "工序名稱",
    description: "工序的名稱",
  },
  op_code: {
    key: "op_code",
    label: "工序編號",
    description: "工序的編號",
  },
  op_description: {
    key: "op_description",
    label: "描述",
    description: "工序的描述",
  },
  op_order: {
    key: "op_order",
    label: "工序",
    description: "工序的執行順序",
  },
  /* --- equipment (R) --- */
  device_name: {
    key: "device_name",
    label: "設備名稱",
    description: "執行工序的設備名稱",
  },
  station_name: {
    key: "station_name",
    label: "報工站名稱",
    description: "報工站的名稱",
  },
  /* --- worker (R) --- */
  worker_id: {
    key: "worker_id",
    label: "員工編號",
    description: "執行工序的員工編號",
  },
  worker_name: {
    key: "worker_name",
    label: "員工名稱",
    description: "執行工序的員工姓名",
  },
  /* --- work order (O) --- */
  start_time: {
    key: "start_time",
    label: "開工時間",
    description: "工單開始執行的時間",
  },
  end_time: {
    key: "end_time",
    label: "結束時間",
    description: "工單完成的時間",
  },
  metrics: {
    key: "metrics",
    label: "指標",
    description: "工單的指標數據", ///
  },
  estimated_time: {
    key: "estimated_time",
    label: "預計開工時間",
    description: "預計開始執行的時間",
  },
  remarks: { key: "remarks", label: "描述", description: "備註說明" },
  deadline: {
    key: "deadline",
    label: "預計交期",
    description: "預計完成的時間",
  },
  work_order_unit: {
    key: "work_order_unit",
    label: "工單單位",
    description: "工單的單位",
  },
  track_no_id: {
    key: "track_no_id",
    label: "追蹤批號",
    description: "用於追蹤的批次編號",
  },
  work_order_priority_ranking: {
    key: "work_order_priority_ranking",
    label: "工單優先順序",
    description: "工單執行的優先級",
  },
  default_warehouse_name: {
    key: "default_warehouse_name",
    label: "預設倉庫位置名稱",
    description: "工單所屬的預設倉庫名稱",
  },
  default_warehouse_storage_name: {
    key: "default_warehouse_storage_name",
    label: "預設倉儲位置名稱",
    description: "工單所屬的預設倉庫儲位名稱",
  },
  availability_time: {
    key: "availability_time",
    label: "稼動時間",
    description: "工單的稼動時間",
  },
  good: {
    key: "good",
    label: "良品數量",
    description: "工單的良品數量",
  },
  order_due_date: {
    key: "order_due_date",
    label: "訂單交期",
    description: "工單的訂單交期",
  },
  /* --- product (O) --- */
  memo: {
    key: "memo",
    label: "備註",
    description: "備註說明",
  },
  category: {
    key: "category",
    label: "分類",
    description: "物料的分類",
  },
  product_type: {
    key: "product_type",
    label: "物料類型",
    description: "物料的類型（場內製造或外包）",
  },
  minimum_stock_level: {
    key: "minimum_stock_level",
    label: "最低庫存",
    description: "物料的最低庫存數量",
  },
  specification: {
    key: "specification",
    label: "規格",
    description: "物料的規格描述",
  },
  /* --- wooh (O) --- */
  shift: {
    key: "shift",
    label: "班別",
    description: "小工單的班別",
  },
  device_type: {
    key: "device_type",
    label: "設備類型",
    description: "小工單的設備類型",
  },
  description: {
    key: "description",
    label: "描述",
    description: "小工單的描述",
  },
  defect: {
    key: "defect",
    label: "不良品數量",
    description: "小工單的不良品數量",
  },
  std_tp: {
    key: "std_tp",
    label: "標準準備時間",
    description: "小工單的標準準備時間（分）",
  },
  std_ts: {
    key: "std_ts",
    label: "標準單位作業時間（分／個）",
    description: "每做一個的標準作業時間",
  },
  std_work_time: {
    key: "std_work_time",
    label: "標準作業時間（分）",
    description: "所有做完總共的標準作業時間",
  },
  act_work_time: {
    key: "act_work_time",
    label: "實際作業時間",
    description: "小工單的實際作業時間",
  },
  defect_reason: {
    key: "defect_reason",
    label: "不良原因",
    description: "不良品的原因",
  },
  abnormal_status: {
    key: "abnormal_status",
    label: "異常狀態",
    description: "異常狀態",
  },
  op_category_name: {
    key: "op_category_name",
    label: "工序類別名稱",
    description: "小工單所屬工序的類別名稱",
  },
  std_tp_end_time: {
    key: "std_tp_end_time",
    label: "前置作業結束時間",
    description: "小工單的前置作業結束時間",
  },
  control_type: {
    key: "control_type",
    label: "控制類型",
    description: "小工單的控制類型（無、完工、數量）",
  },
  control_value: {
    key: "control_value",
    label: "控制值",
    description: "小工單的控制值",
  },
  start_count: {
    key: "start_count",
    label: "開工時次數",
    description: "小工單開工時的機台計算次數",
  },
  end_count: {
    key: "end_count",
    label: "完工時次數",
    description: "小工單完工時的機台計算次數",
  },
  pilot_run_qty: {
    key: "pilot_run_qty",
    label: "試產數量",
    description: "小工單的試產數量",
  },
  op_pcs_per_act: {
    key: "op_pcs_per_act",
    label: "每次作業件數",
    description: "機台作動一次產生的件數",
  },
  device_availability: {
    key: "device_availability",
    label: "設備稼動率",
    description: "設備從開工到完工的稼動率",
  },
  device_total_time: {
    key: "device_total_time",
    label: "設備總運行時間",
    description: "設備從開工到完工的總運行時間",
  },
  device_off_time: {
    key: "device_off_time",
    label: "設備停機時間",
    description: "設備從開工到完工的停機時間",
  },
  device_run_time: {
    key: "device_run_time",
    label: "設備運行時間",
    description: "設備從開工到完工的運行時間",
  },
  device_idle_time: {
    key: "device_idle_time",
    label: "設備閒置時間",
    description: "設備從開工到完工的閒置時間",
  },
  device_down_time: {
    key: "device_down_time",
    label: "設備停機時間",
    description: "設備從開工到完工的停機時間",
  },
  op_support_unit_value: {
    key: "op_support_unit_value",
    label: "工序第二單位值",
    description: "小工單的工序第二單位值",
  },
  work_order_op_history_id: {
    key: "work_order_op_history_id",
    label: "工序單號",
    description: "工序工單的編號",
  },
  work_order_op_history_priority_ranking: {
    key: "work_order_op_history_priority_ranking",
    label: "小工單優先順序",
    description: "小工單執行的優先級",
  },
  pilot_run_defect: {
    key: "pilot_run_defect",
    label: "試產不良品數量",
    description: "小工單的試產不良品數量",
  },
  pilot_run_good: {
    key: "pilot_run_good",
    label: "試產良品數量",
    description: "小工單的試產良品數量",
  },
  pilot_run_op_support_unit_value: {
    key: "pilot_run_op_support_unit_value",
    label: "試產工序第二單位值",
    description: "小工單的試產工序第二單位值",
  },
  op_report_type: {
    key: "op_report_type",
    label: "工序報工行為",
    description: "小工單的工序報工行為（單人、多人）",
  },
  co_work_tag: {
    key: "co_work_tag",
    label: "協作標籤",
    description: "小工單的協作標籤",
  },
  abnormal_time: {
    key: "abnormal_time",
    label: "異常時間",
    description: "小工單的異常時間",
  },
  exclusive_time: {
    key: "exclusive_time",
    label: "除外時間",
    description: "小工單的除外時間",
  },
  routine_exclusive_time: {
    key: "routine_exclusive_time",
    label: "例行除外時間",
    description: "小工單的例行除外時間",
  },
  support_unit_good: {
    key: "support_unit_good",
    label: "第二單位良品數量",
    description: "小工單的第二單位良品數量",
  },
  support_unit_defect: {
    key: "support_unit_defect",
    label: "第二單位不良品數量",
    description: "小工單的第二單位不良品數量",
  },
  op_spc_report_type: {
    key: "op_spc_report_type",
    label: "工序 SPC 報告類型",
    description: "小工單的工序 SPC 報告類型",
  },
  rework_tag: {
    key: "rework_tag",
    label: "重工標籤",
    description: "小工單的重工標籤",
  },
  /* --- route (O) --- */
  img_url: {
    key: "img_url",
    label: "圖片 URL",
    description: "途程圖片的連結地址",
  },
  /* --- operation (O) --- */
  pcs_per_act: {
    key: "pcs_per_act",
    label: "每次作業件數",
    description: "機台作動一次產生的件數",
  },
  support_unit_value: {
    key: "support_unit_value",
    label: "第二單位值",
    description: "工序的第二單位值",
  },
  /* --- worker (O) --- */
  face_api_js_descriptor: {
    key: "face_api_js_descriptor",
    label: "Face API 描述",
    description: "員工的 Face API 描述",
  },
};

export function cleanBlueprint(obj) {
  // Helper utilities for clarity
  const isEmpty = (v) => v === null || v === undefined || v === "";
  const isPresent = (v) => !isEmpty(v);

  if (Array.isArray(obj)) {
    // Map children, then filter out "empty" entries.
    return obj.map(cleanBlueprint).filter((item) => {
      if (item === null || item === undefined) return false;
      if (Array.isArray(item)) return item.length > 0;
      if (typeof item === "object") {
        // keep object only if none of its fields are "partially empty"
        const keys = Object.keys(item);
        // original behavior: drop if ANY field is empty
        const hasEmptyField = keys.some((k) => isEmpty(item[k]));
        return !hasEmptyField;
      }
      // primitives: keep only if present
      return isPresent(item);
    });
  } else if (typeof obj === "object" && obj !== null) {
    const cleaned = {};

    for (let [key, value] of Object.entries(obj)) {
      // skip plainly empty values
      if (isEmpty(value)) continue;

      // Special handling per key (non-mutating)
      if (
        key === "connectionConfig" &&
        typeof value === "object" &&
        value !== null
      ) {
        const cfg = { ...value };
        if (cfg.type === "database" && cfg.api) delete cfg.api;
        if (cfg.type === "api" && cfg.database) delete cfg.database;
        cleaned[key] = cfg;
        continue;
      }

      if (key === "joinConditions" && Array.isArray(value)) {
        const filtered = value.filter(
          (item) =>
            typeof item === "object" &&
            item !== null &&
            Object.values(item).every((v) => isPresent(v))
        );
        if (filtered.length > 0) cleaned[key] = filtered;
        continue;
      }

      if (
        key === "filterConditions" &&
        typeof value === "object" &&
        value !== null
      ) {
        const filtered = {};
        for (let [k, v] of Object.entries(value)) {
          if (Array.isArray(v) && v.length === 0) continue;
          if (!isEmpty(v)) filtered[k] = v;
        }
        if (Object.keys(filtered).length > 0) cleaned[key] = filtered;
        continue;
      }

      if (
        key === "transformations" &&
        typeof value === "object" &&
        value !== null
      ) {
        // work on a shallow copy
        const t = { ...value };
        if (t.type === "calculation" && t.content) delete t.content;
        if (t.type === "concat" && t.formula) delete t.formula;

        const filtered = {};
        for (let [k, v] of Object.entries(t)) {
          if (!isEmpty(v)) filtered[k] = v;
        }

        // if only 'type' remains, treat as empty (preserve previous logic)
        if (
          !(
            Object.keys(filtered).length === 1 &&
            Object.keys(filtered)[0] === "type"
          )
        ) {
          if (Object.keys(filtered).length > 0) cleaned[key] = filtered;
        }
        continue;
      }

      if (key === "updateRule" && typeof value === "object" && value !== null) {
        const ur = { ...value };
        if (ur.updateCondition === "any" && ur.columns) delete ur.columns;
        const nested = cleanBlueprint(ur);
        if (typeof nested === "object" && Object.keys(nested).length > 0)
          cleaned[key] = nested;
        continue;
      }

      if (key === "blueprintMemo") {
        if (value !== "") value = "\n" + value;
      }

      if (key === "columns" && Array.isArray(value)) {
        const filtered = value.filter((item) => {
          if (typeof item !== "object" || item === null) return false;
          const { columnSource, columnName } = item;
          return isPresent(columnSource) && isPresent(columnName);
        });
        if (filtered.length > 0) {
          cleaned[key] = filtered;
        }
        continue;
      }

      // Recurse for other keys
      const nested = cleanBlueprint(value);
      const keepNested =
        (typeof nested === "object" &&
          nested !== null &&
          Object.keys(nested).length > 0) ||
        (Array.isArray(nested) && nested.length > 0) ||
        (typeof nested !== "object" && nested !== "");

      if (keepNested) cleaned[key] = nested;
    }

    return cleaned;
  }

  // primitives (string/number/boolean) are returned as-is
  return obj;
}
